import { render, staticRenderFns } from "./AddEntityModal.vue?vue&type=template&id=0c0faf74&lang=pug"
import script from "./AddEntityModal.vue?vue&type=script&lang=js"
export * from "./AddEntityModal.vue?vue&type=script&lang=js"
import style0 from "./AddEntityModal.vue?vue&type=style&index=0&id=0c0faf74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports